module.exports = __webpack_public_path__ + "static/media/PM1.24b74732.JPG";